import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export interface IGuauPaso {
  numero: number;
  titulo: string;
  descripcion: string;
  url: string;
  icono: string;
  tipo: 'perfil' | 'descubre' | 'muros';
}

@Component({
  selector: 'app-como-funciona',
  templateUrl: './como-funciona.component.html',
  styleUrls: ['./como-funciona.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComoFuncionaComponent {
  @Input() baseUrl = '/';

  readonly pasos: IGuauPaso[] = [
    {
      numero: 1,
      titulo: 'Crea tu perfil',
      descripcion: 'Regístrate y añade a tu mascota con sus fotos, datos y personalidad.',
      url: 'register',
      icono: 'fa-solid fa-user-plus',
      tipo: 'perfil'
    },
    {
      numero: 2,
      titulo: 'Descubre y conecta',
      descripcion: 'Encuentra amigos, sigue perfiles, comenta y comparte momentos especiales.',
      url: 'perfiles',
      icono: 'fa-solid fa-images',
      tipo: 'descubre'
    },
    {
      numero: 3,
      titulo: 'Comparte y disfruta',
      descripcion: 'Participa en los muros, comparte tus historias y descubre a la comunidad iGuau.',
      url: 'muros',
      icono: 'fa-solid fa-comments',
      tipo: 'muros'
    }
  ];

  trackByNumero(_index: number, paso: IGuauPaso): number {
    return paso.numero;
  }

  enlace(ruta: string): string {
    return `${this.baseUrl.replace(/\/+$/, '')}/${ruta.replace(/^\/+/, '')}`;
  }
}
